module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Regular.913f146b.ttf";